import { Yield } from '../../abacus/interfaces/yield.interface'

export const enforcementYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
